import React from 'react'
import { Grid, Stack, Typography, useTheme } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { NumberField } from 'src/Libs/inputs/react-hook-form'
import { DynamicTariffSettingsFormFields } from 'src/Libs/dynamic-tariff-settings/constants'
import { UnitTypes } from 'src/Libs/types'
import { useApp } from 'src/Hooks'
import { PowerPriceContainer } from './PowerPriceContainer'

interface Props {
  hasWritingRights: boolean
}

/**
 * component to show and edit static power price of dynamic tariff settings form
 */
const StaticPowerPriceSettingsForm: React.FC<Props> = ({ hasWritingRights }) => {
  const theme = useTheme()
  const { t } = useCustomTranslation()
  const { isMobile: isDownSm } = useApp()

  return (
    <PowerPriceContainer sx={{ backgroundColor: theme.palette.grey.grey07 }}>
      <Grid container alignItems={'center'}>
        <Grid item xs={12} sm={8} md={6}>
          <Typography variant="body1" display="flex">
            {t('dynamic-tariff-settings.static-power-price.title')}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} md={6}>
          <Stack flexDirection="row" justifyContent={isDownSm ? 'center' : 'end'} alignItems="center">
            <NumberField
              disabled={!hasWritingRights}
              sx={{ ...(isDownSm ? { width: '100%' } : { maxWidth: theme => theme.spacing(25) }) }}
              name={DynamicTariffSettingsFormFields.PowerPrices}
              suffix={UnitTypes.centsPerKiloWattHour}
              inputProps={{ style: { textAlign: 'right' } }}
            />
          </Stack>
        </Grid>
      </Grid>
    </PowerPriceContainer>
  )
}

export default StaticPowerPriceSettingsForm
